'use client';

import { createContext } from 'react';

export interface FormDirtyContextValue {
  reportDirty: (formId: string, isDirty: boolean) => void;
  reportSubmitted: (formId: string) => void;
}

export const FormDirtyContext = createContext<FormDirtyContextValue | null>(null);
